import { REVIEWER_ACTIONS } from "./REVIEWER_ACTIONS"


export function reviewerReducer(state, action) {
  switch (action.type) {
    case REVIEWER_ACTIONS.SET_REVIEWER:
      return {
        ...state,
        reviewer: action.payload.reviewer,
      }
    case REVIEWER_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}